/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const CreatePraetorBody = zod
	.object({
		praetor: zod.object({
			name: zod.string().optional().describe('Praetor name')
		})
	})
	.describe('Request body for creating or updating a praetor');

export type CreatePraetorBody = zod.input<typeof CreatePraetorBody>;
export type CreatePraetorBodyOutput = zod.output<typeof CreatePraetorBody>;
